export function initHamburgerMenu() {
	// Cache the relevant DOM nodes.
	const hamburgerMenu = document.querySelector('.hamburger-menu');
    const hamburgerButton = document.querySelector('.menu-icon-hamburger .sidebar-link');
    const openButton = document.querySelector('.hamburger-open');
    const closeButton = document.querySelector('.hamburger-close');
    const blurContent = document.querySelector('.content');

    // Make sure we have the required content in the DOM before doing anything else.
    if (!hamburgerButton || !hamburgerMenu || !openButton || !closeButton || !blurContent) {
        return;
    }

    // Toggle the hamburger menu when the button is clicked.
    hamburgerButton.addEventListener('click', (el) => {
        toggleHamburgerMenu(hamburgerButton, hamburgerMenu, blurContent, openButton, closeButton);
    });

    // Listen for clicks outside of the hamburger menu
    // and if the menu is active, remove it.
    blurContent.addEventListener('click', (el) =>{
        if (hamburgerMenu.classList.contains('hamburger-active')) {
            toggleHamburgerMenu(hamburgerButton, hamburgerMenu, blurContent, openButton, closeButton);
        }
    });
}

function toggleHamburgerMenu(hamburgerButton, hamburgerMenu, blurContent, openButton, closeButton) {
    if (!hamburgerButton.classList.contains('footer-menu-active')) {
        toggleButtonOpen(openButton, closeButton);
        hamburgerButton.classList.add('footer-menu-active');
        hamburgerMenu.classList.remove('d-none');
        hamburgerMenu.classList.remove('fadeOutLeft');
        hamburgerMenu.classList.add('fadeInLeft');
        blurContent.classList.toggle('blur--low');
        hamburgerMenu.classList.toggle('hamburger-active');
    } else {
        toggleButtonClose(openButton, closeButton);
        hamburgerButton.classList.remove('footer-menu-active');
        hamburgerMenu.classList.remove('fadeInLeft');
        hamburgerMenu.classList.add('fadeOutLeft');
        blurContent.classList.toggle('blur--low');
        hamburgerMenu.classList.toggle('hamburger-active');
    }
}

function toggleButtonOpen(openButton, closeButton) {
    openButton.classList.add('fadeOutLeft');
    openButton.classList.remove('fadeInLeft');
    openButton.classList.add('d-none');
    closeButton.classList.add('fadeInRight');
    closeButton.classList.remove('d-none');
}

function toggleButtonClose(openButton, closeButton) {
    openButton.classList.remove('fadeOutLeft');
    openButton.classList.add('fadeInLeft');
    openButton.classList.remove('d-none');
    closeButton.classList.remove('fadeInRight');
    closeButton.classList.add('d-none');
}
